import { addDays, addMonths, startOfDay, startOfMonth, subDays } from 'date-fns';

import { $OrderSwitchReasonDto } from '@eneco/dc-be/client/schemas.gen';
import type { OrderSwitchReasonDto } from '@eneco/dc-be/client/types.gen';

import { MOVE_TO_ENECO, NEW_METER_CONNECTION, TAKE_OVER_METER_CONNECTION_OLD_INHABITANT } from './constants';
import { toMonthInputValue } from './monthDateUtils';

function toDateInputValue(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function getTodayEndOfDay(): Date {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
}

export const parseOrderSwitchReason = (reason: unknown): OrderSwitchReasonDto | undefined => {
  for (const validReason of $OrderSwitchReasonDto.enum) {
    if (reason === validReason) {
      return validReason;
    }
  }

  return undefined;
};

export const getStartDateDateBounds = (reason: OrderSwitchReasonDto | undefined): { min?: Date; max?: Date } => {
  if (!reason) {
    return {};
  }

  const today = getTodayEndOfDay();

  if (reason === MOVE_TO_ENECO) {
    return {
      min: startOfDay(addDays(today, 25)),
      max: addDays(today, 365),
    };
  }

  if (reason === NEW_METER_CONNECTION) {
    return {
      min: startOfDay(addDays(today, 1)),
      max: addDays(today, 365),
    };
  }

  if (reason === TAKE_OVER_METER_CONNECTION_OLD_INHABITANT) {
    return {
      min: startOfDay(subDays(today, 29)),
      max: addDays(today, 30),
    };
  }

  return {};
};

export const getStartDateBounds = (reason: OrderSwitchReasonDto | undefined): { min?: string; max?: string } => {
  const { min, max } = getStartDateDateBounds(reason);

  return {
    min: min ? toDateInputValue(min) : undefined,
    max: max ? toDateInputValue(max) : undefined,
  };
};

export const getInstallationDateMax = (inputType: 'month' | 'date'): string => {
  const today = new Date();
  return inputType === 'month' ? toMonthInputValue(today) : toDateInputValue(today);
};

export const getMaintenanceDateMin = (inputType: 'month' | 'date'): string => {
  const minDate = startOfMonth(addMonths(new Date(), 2));
  return inputType === 'month' ? toMonthInputValue(minDate) : toDateInputValue(minDate);
};
